import React from 'react';
import Flickity from 'react-flickity-component';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import 'flickity/css/flickity.css';

const flickityOptions = {
  initialIndex: 1,
  groupCells: true,
  pageDots: false,
  prevNextButtons: false,
  contain: true,
  percentPosition: false,
  cellAlign: 'left',
  watchCSS: true,
  draggable: false
};

interface Props {
  children: React.ReactNode;
  options?: any;
}

const Carousel = React.forwardRef(({ children, options }: Props, externalRef) => {
  const mergedOptions = { ...flickityOptions, ...options };

  return (
    <CarouselWrap>
      <Flickity
        className="carousel"
        elementType="div"
        options={mergedOptions}
        disableImagesLoaded={false}
        reloadOnUpdate={true}
        static
        flickityRef={(carouselRef) => {
          if (externalRef) externalRef.current = carouselRef;
        }}
      >
        {children}
      </Flickity>
    </CarouselWrap>
  );
});

Carousel.displayName = 'Carousel';

export default Carousel;

const CarouselWrap = styled.div`
  .flickity-page-dots .dot {
    background: ${Colors.navyBlue};
  }
  .flickity-page-dots .dot.is-selected {
    background: ${Colors.gold};
  }

  .flickity-prev-next-button {
    width: 40px;
    height: 40px;
    border-radius: 0;
    background: ${Colors.ecru};

    .flickity-button-icon {
      left: 30%;
      top: 30%;
      width: 40%;
      height: 40%;
    }

    &.next {
      right: 0;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }

    &.previous {
      left: 0;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }
`;
